<template>
  <div>
    <div class="flex-fill d-flex flex-column justify-content-center">
      <div class="container-narrow py-6">
        <div class="text-center mb-5 mb-4 mt-4">
          <a href="."
            ><img
              :src="require('../assets/images/logo-dark.png')"
              height="36"
              alt=""
          /></a>
        </div>
        <div class="card">
          <div class="card-header justify-content-center">
            <h3 class="card-title">付款</h3>
          </div>
          <div class="card-body">
            <div
              v-if="alertStatus === ''"
              class="alert alert-info"
              role="alert"
            >
              {{ alertMsg }} {{ expireTime }}
            </div>
            <div
              v-else-if="alertStatus === 'success'"
              class="alert alert-success"
              role="alert"
            >
              {{ alertMsg }}
            </div>
            <div v-else class="alert alert-danger" role="alert">
              {{ alertMsg }}
            </div>
            <div class="alert alert-warning" role="alert">
              注意！USD2PAY 不支援從合約轉出的的交易，請使用原生地址轉帳。
            </div>
            <div class="row mb-3">
              <div class="col-2"></div>
              <div class="col-8 d-flex justify-content-center">
                <vue-qr v-bind:text="this.qrcodeText" :size="200"></vue-qr>
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row mb-3 align-items-center payment-detail">
              <div class="col-12">
                <div class="row mb-3 align-items-center">
                  <div class="col-3">付款對象</div>
                  <div class="col-9">{{ form.storeName }}</div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-3">付款金額</div>
                  <div class="col-9">{{ form.amount }}</div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-3">付款地址</div>
                  <div class="col-9">
                    {{ form.address }}
                  </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-3">公鏈</div>
                  <div class="col-9">
                    {{ form.paymentProtocol }}
                  </div>
                </div>
                <div class="row mb-3 align-items-center">
                  <div class="col-3">幣種</div>
                  <div class="col-9">
                    {{ form.currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-muted mt">
          <router-link to="/login">登入</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr';
import moment from 'moment';
import {Socket} from '../store/socket';
export default {
  data() {
    return {
      expireTime: '',
      msg: '',
      alertStatus: '',
      alertMsg: '將自動偵測交易狀態，訂單有效時間：',
      form: {
        address: this.$route.params.address,
        amount: this.$route.params.amount,
        cryptoAmount: this.$route.params.cryptoAmount,
        currency: this.$route.params.currency,
        orderId: this.$route.params.orderId,
        merchantId: this.$route.params.merchantId,
        storeName: '',
        paymentProtocol: '',
      },
      qrcodeText: '',
      returnUrl: '',
    };
  },
  components: {
    VueQr,
  },
  methods: {
    async runCheckOrderStatus() {
      this.checkOrderStatus() &&
        setInterval(async () => {
          this.checkOrderStatus();
        }, 10000);
    },
    async subscribeSocketEvents() {
      this.socket.on('block_confirmation', blockNumber => {
        this.alertMsg = `正在執行區塊確認，確認數: ${blockNumber}/6。訂單有效時間：`;
      });
    },
    async checkOrderStatus() {
      const api = `${process.env.VUE_APP_API_URL}/customer_api/${process.env.VUE_APP_API_VERSION}/merchant/${this.form.merchantId}/order/${this.form.orderId}/status`;
      try {
        const res = await this.$http.get(api);
        this.expireTime = res.data.data.expireTime;
        if (
          res.data.data.walletRelease ||
          moment(res.data.data.expireTime).isBefore(moment())
        ) {
          this.alertStatus = 'error';
          this.alertMsg =
            '訂單及收款地址已過期，充值到該地址將導致您的加密貨幣無法找回。';
        } else {
          if (res.data.data.paymentStatus) {
            if (this.returnUrl !== '') {
              this.alertStatus = 'success';
              this.alertMsg = '交易完成，3秒後將自動跳轉';
              setTimeout(() => {
                window.location.href = this.returnUrl;
              }, 3000);
            } else if (
              res.data.data.paymentStatus == -1 ||
              res.data.data.paymentStatus == 2
            ) {
              window.location.href = 'https://usd2pay.com';
            } else {
              throw '';
            }
          }
        }
      } catch (err) {
        this.alertStatus = 'error';
        this.alertMsg = '錯誤';
      }
    },
    async getSettings() {
      const api = `${process.env.VUE_APP_API_URL}/customer_api/${process.env.VUE_APP_API_VERSION}/merchant/${this.form.merchantId}/order/${this.form.orderId}/merchantSetting/${this.form.address}/${this.form.currency}/${this.form.amount}`;
      try {
        const res = await this.$http.get(api, {
          headers: {
            merchantId: this.form.merchantId,
            orderId: this.form.orderId,
          },
        });
        if (res.data.status === 'success') {
          this.returnUrl = res.data.data.merchantSetting.returnUrl;
          this.form.storeName = res.data.data.merchantSetting.storeName;
          this.form.paymentProtocol =
            res.data.data.merchantSetting.paymentProtocol == 'tronUSDT'
              ? '波場 (Tron)'
              : '以太坊 (Ethereum)';
          this.qrcodeText =
            res.data.data.merchantSetting.paymentProtocol == 'tronUSDT'
              ? this.$route.params.address
              : 'ethereum:' +
                this.$route.params.address +
                '?value=' +
                this.$route.params.cryptoAmount;
        } else {
          throw '';
        }
      } catch (err) {
        this.$router.push('../login');
      }
    },
  },
  async created() {
    await this.getSettings();
    await this.runCheckOrderStatus();

    this.socket = new Socket(process.env.VUE_APP_API_URL);
    this.socket = await this.socket.connectSocket();
    await this.subscribeSocketEvents();
  },
};
</script>

<style scoped>
.page {
  padding-top: 100px;
}

.payment-detail {
  font-size: 0.9rem;
  font-weight: 400;
}
</style>
